// Lightweight ingredient quantity parser and scaler for the frontend

// Parse a leading numeric quantity (supports: 1, 1.5, 1/2, 1 1/2)
export function parseLeadingQuantity(text) {
  if (!text || typeof text !== 'string') return null;
  const trimmed = text.trim();

  // Match mixed number (e.g., "1 1/2"), fraction ("1/2"), decimal ("1.5"), or integer ("2")
  const match = trimmed.match(/^((?:\d+\s+\d+\/\d+)|(?:\d+\/\d+)|(?:\d+\.\d+)|(?:\d+))\s*(.*)$/);
  if (!match) return null;

  const numberPart = match[1];
  const rest = match[2] || '';

  // Convert numberPart to numeric value
  let value = 0;
  if (numberPart.includes(' ')) {
    // Mixed number: A B/C
    const [wholeStr, fracStr] = numberPart.split(/\s+/);
    const [num, den] = fracStr.split('/');
    value = parseFloat(wholeStr) + (parseFloat(num) / parseFloat(den));
  } else if (numberPart.includes('/')) {
    const [num, den] = numberPart.split('/');
    value = parseFloat(num) / parseFloat(den);
  } else {
    value = parseFloat(numberPart);
  }

  // Split rest into unit (optional) + name
  // Heuristic: if first token is alphabetic, treat as unit; otherwise name starts immediately
  const tokens = rest.trim().split(/\s+/);
  let unit = '';
  let name = rest.trim();
  if (tokens.length > 0 && /^[A-Za-zµμ]+\.?[A-Za-z]*$/.test(tokens[0])) {
    unit = tokens[0];
    name = tokens.slice(1).join(' ');
  }

  return {
    value: isNaN(value) ? 0 : value,
    unit,
    name: name.trim(),
    original: trimmed
  };
}

export function formatQuantity(value) {
  // Keep up to 2 decimals; trim trailing zeros
  const rounded = Math.round(value * 100) / 100;
  if (Number.isInteger(rounded)) return String(rounded);
  return rounded.toString();
}

export function scaleIngredientLine(line, scale) {
  const parsed = parseLeadingQuantity(line);
  if (!parsed || parsed.value === 0) return line; // nothing to scale
  const scaledValue = parsed.value * scale;
  const qty = formatQuantity(scaledValue);
  const unitAndName = [parsed.unit, parsed.name].filter(Boolean).join(' ');
  return unitAndName ? `${qty} ${unitAndName}` : `${qty}`;
}

export default {
  parseLeadingQuantity,
  scaleIngredientLine
};


